<template>
    <div>
        <main
            id="content"
            class="content-default prodetail-content relative-section"
        >
            <div class="container">
                <div class="relative-section">
                    <div class="brecrump font-bai">
                        <router-link to="/">{{ $t("app.Home") }}</router-link
                        >/
                        <router-link to="/result">
                            {{ $t("app.Recherche") }} </router-link
                        >/
                        <b>{{ getTranslate(room.Name) }}</b>
                    </div>
                    <div class="row">
                        <div class="col-md-8 prodetail-left">
                            <RoomImagesSlide :room="room" />
                            <h1 class="font-balo font-bold">
                                {{ getTranslate(room.Name) }}
                            </h1>
                            <div
                                class="des font-bai"
                                v-html="getTranslate(room.Description)"
                            ></div>
                            <div class="the-tab">
                                <div class="text-center tab-nav">
                                    <ul class="list-inline font-bai font-bold">
                                        <li
                                            class="item-inline item-photo pointer"
                                            :class="{
                                                active:
                                                    currentTab ===
                                                    'productDetail1'
                                            }"
                                        >
                                            <a
                                                @click.prevent="
                                                    setTab('productDetail1')
                                                "
                                                >{{ $t("app.Situation") }}</a
                                            >
                                        </li>
                                        <li
                                            class="item-inline"
                                            :class="{
                                                active:
                                                    currentTab ===
                                                    'productDetail2'
                                            }"
                                        >
                                            <a
                                                @click.prevent="
                                                    setTab('productDetail2')
                                                "
                                                href="#productDetail2"
                                                >{{ $t("app.équipement") }}</a
                                            >
                                        </li>
                                        <li
                                            class="item-inline"
                                            :class="{
                                                active:
                                                    currentTab ===
                                                    'productDetail3'
                                            }"
                                        >
                                            <a
                                                href="#productDetail3"
                                                @click.prevent="
                                                    setTab('productDetail3')
                                                "
                                            >
                                                {{
                                                    $t(
                                                        "app.Nos services et activités"
                                                    )
                                                }}
                                            </a>
                                        </li>
                                        <li
                                            class="item-inline"
                                            :class="{
                                                active:
                                                    currentTab ===
                                                    'productDetail4'
                                            }"
                                        >
                                            <a
                                                href="#productDetail4"
                                                @click.prevent="
                                                    setTab('productDetail4')
                                                "
                                                >{{ $t("app.localisation") }}</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div
                                    class="content-tab"
                                    id="productDetail1"
                                    :class="{
                                        active: currentTab === 'productDetail1'
                                    }"
                                >
                                    <template v-if="situations && situations.length > 0">
                                        <CoolLightBox
                                            :items="situations"
                                            :index="index"
                                            @close="index = null"
                                        ></CoolLightBox>
                                    </template>
                                    <ul class="list-inline gallery-list">
                                        <li
                                            class="item-inline"
                                            v-for="(image,
                                            imageIndex) in situations"
                                            :key="imageIndex"
                                        >
                                            <a
                                                href="#"
                                                class="image-fit"
                                                @click.prevent="
                                                    index = imageIndex
                                                "
                                            >
                                                <img :src="image" />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div
                                    class="content-tab"
                                    id="productDetail2"
                                    :class="{
                                        active: currentTab === 'productDetail2'
                                    }"
                                >
                                    <ul
                                        class="list-inline camping-svlist"
                                        v-if="equiments.length > 0"
                                    >
                                        <li
                                            class="item-inline"
                                            v-for="(equiment,
                                            index) in equiments"
                                            :key="index"
                                        >
                                            <a
                                                @click.prevent
                                                class="text-center svitem font-bai"
                                            >
                                                <div
                                                    class="image"
                                                    v-if="equiment.icon"
                                                >
                                                    <img
                                                        :src="equiment.icon"
                                                        alt
                                                    />
                                                </div>
                                                <b>{{ equiment.name }}</b>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div
                                    class="content-tab"
                                    id="productDetail3"
                                    :class="{
                                        active: currentTab === 'productDetail3'
                                    }"
                                >
                                    <ul
                                        class="list-inline camping-svlist"
                                        v-if="services.length > 0"
                                    >
                                        <li
                                            class="item-inline"
                                            v-for="(item, index) in services"
                                            :key="index"
                                        >
                                            <a
                                                @click.prevent
                                                class="text-center svitem font-bai"
                                            >
                                                <div
                                                    class="image"
                                                    v-if="item.icon"
                                                >
                                                    <img :src="item.icon" />
                                                </div>
                                                <b>{{ item.name }}</b>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div
                                    class="content-tab"
                                    id="productDetail4"
                                    :class="{
                                        active: currentTab === 'productDetail4'
                                    }"
                                >
                                    <div
                                        class="row"
                                        v-if="
                                            room &&
                                                room.info &&
                                                room.info.location
                                        "
                                    >
                                        <div class="col-md-7">
                                            <div
                                                id="detailMap"
                                                v-html="
                                                    room.info.location.location
                                                "
                                            ></div>
                                        </div>
                                        <div
                                            class="col-md-5 font-bai"
                                            v-html="
                                                room.info.location.description
                                            "
                                        ></div>
                                    </div>
                                </div>
                            </div>
                            <RoomComments :room="room" />
                        </div>
                        <div class="col-md-4">
                            <RoomDetailCheckout :room="room" />
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <LandingValues />
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import LandingValues from "@/components/LandingValues";
import RoomImagesSlide from "@/components/RoomImagesSlide";
import RoomDetailCheckout from "@/components/RoomDetailCheckout";
import RoomComments from "@/components/RoomComments";
import CoolLightBox from "vue-cool-lightbox";
import { get, find } from "lodash";
import { setDescriptionPage } from "@/helper/helper";
export default {
    name: "RoomPage",
    components: {
        LandingValues,
        RoomImagesSlide,
        RoomDetailCheckout,
        RoomComments,
        CoolLightBox
    },
    data() {
        return {
            currentTab: "productDetail1",
            services: [],
            situations: [],
            equiments: [],
            index: null
        };
    },
    mounted() {
        this.getCategories();
        this.getTypes();

        const roomId = this.$route.params.id;
        const roomCategory = find(this.references, item => item.id === roomId);
        if (roomCategory) {
            this.getRoom(roomCategory)
                .then(() => {
                    setDescriptionPage(
                        this.getTranslate(this.room.Description)
                    );
                })
                .catch(() => this.$router.push("/"));
        } else {
            this.$router.push("/");
        }
        this.services = get(this.room, "info.services", []);
        this.equiments = get(this.room, "info.equiment", []);
        this.situations = get(this.room, "info.situations", []);
    },
    computed: {
        ...mapState({
            references: state => get(state, "hotels.allReferences", []),
            room: state => get(state, "hotels.room", {}),
            filter: state => get(state, "hotels.filter", {}),
            lang: state => get(state, "app.lang", "fr")
        })
    },
    methods: {
        ...mapActions("hotels", ["getRoom"]),
        ...mapActions("categories", ["getCategories"]),
        ...mapActions("types", ["getTypes"]),
        setTab(tab) {
            this.currentTab = tab;
        },

        getTranslate(object) {
            if (this.lang === "fr" && get(object, "fr-FR")) {
                return get(object, "fr-FR");
            }
            return get(object, "en-US");
        }
    },
    watch: {
        room: function(room) {
            this.services = get(room, "info.services", []);
            this.situations = get(room, "info.situations", []);
            this.equiments = get(room, "info.equiment", []);
        }
    }
};
</script>
